<template>
  <div>
    <div v-if="isLoading" class="loading">Loading&#8230;</div> 
<vue-snotify/>


<div class="columns box is-multiline is-centered">
<div class="column" :class="return_column_width('is-12','is-12')">
 

<div class="columns is-gapless has-text-weight-bold has-text-white" style="margin-top:-1em;margin-bottom:.4em;"> 
    <div class="column is-2"><a @click="switch_view('COURSE')" :class="{active: current_view === 'COURSE' }"  class="button is-fullwidth"><span class="icon is-small"> <i class="fas fa-th-list"></i> </span> <span>COURSES</span></a> </div>
    <div class="column is-2"><a @click="switch_view('COMPETENCE')" :class="{active: current_view === 'COMPETENCE' }"  class="button is-fullwidth"><span class="icon is-small"> <i class="fas fa-ellipsis-h"></i> </span> <span>COMPETENCES</span></a> </div>
    <div class="column is-2"><a @click="switch_view('PROGRAM')" :class="{active: current_view === 'PROGRAM' }"  class="button is-fullwidth"><span class="icon is-small"> <i class="fas fa-sort-alpha-down"></i> </span> <span>PROGRAMS</span></a> </div>
    <div class="column is-5"></div>
    <div class="column is-1">
        <button @click="add_new()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
</div>
<!-- END HEADER  -->

<CompPedProgram v-if="current_view == 'PROGRAM'" ref="childPROG" :key="randomKey()"> </CompPedProgram>
<CompPedCourse v-if="current_view == 'COURSE'" ref="childCOUR" :key="randomKey()"> </CompPedCourse>
<CompPedCompetence v-if="current_view == 'COMPETENCE'" ref="childCOMP" :prog_id='0' :key="randomKey()"> </CompPedCompetence>



</div></div>
  </div>
</template>

<script>
import axios from 'axios'
import CompPedCourse from "@/views/Admin/Comp_Admin_Ped_Course"
import CompPedProgram from "@/views/Admin/Comp_Admin_Ped_Program"
import CompPedCompetence from "@/views/Admin/Comp_Admin_Ped_Competence"



export default {
  name: 'AdminPrograms',
  components: {CompPedCourse, CompPedProgram, CompPedCompetence},
  props: [ ],

    data() {
        return {
            isLoading:false,
            current_view : 'PROGRAM',

            data_courses:[],
        }
    },



methods: {

switch_view:function(view) {
  this.current_view = view
},
add_new:function() {
 if (this.current_view == 'COURSE') {this.$refs.childCOUR.course_new()}
 if (this.current_view == 'COMPETENCE') {this.$refs.childCOMP.competence_new()}
 if (this.current_view == 'PROGRAM') {this.$refs.childPROG.program_new()} 
},

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},


 
}

}
</script>


<style scoped>

.active{
  background-color:LIGHTCYAN;
}

</style>
